import { z } from 'zod';
export const ExecutionContextSchema = z.object({
    project_name: z.string().optional(),
    project_path: z.string().optional(),
    session_id: z.string().uuid().optional(),
    prompt_id: z.string().uuid().optional(),
    user_id: z.string().optional(),
    workspace: z.record(z.any()).optional(),
    cli_session_id: z.string().optional(),
    resume_session: z.boolean().optional(),
});
export const ExecutionOptionsSchema = z.object({
    timeout: z.number().positive().optional(),
    output_directory: z.string().optional(),
    attachments: z.array(z.string()).optional(),
    max_retries: z.number().min(0).max(5).default(5),
    cost_limit_usd: z.number().positive().optional(),
});
export const AgentExecutionRequestSchema = z.object({
    agent: z.string().regex(/^[a-zA-Z0-9_-]+$/),
    prompt: z.string().min(1).max(100000),
    context: ExecutionContextSchema.optional(),
    options: ExecutionOptionsSchema.optional(),
});
export const ExecutionMetadataSchema = z.object({
    execution_time_ms: z.number().nonnegative(),
    tokens_used: z.number().nonnegative().optional(),
    cost_usd: z.number().nonnegative().optional(),
    model_used: z.string().optional(),
    provider: z.string().optional(),
    runner_type: z.string(),
    session_id: z.string().uuid().optional(),
    timestamp: z.string().datetime(),
    retries: z.number().nonnegative().default(0),
});
export const AgentExecutionResultSchema = z.object({
    success: z.boolean(),
    output: z.string(),
    metadata: ExecutionMetadataSchema,
    error: z.string().optional(),
    artifacts: z.array(z.object({
        path: z.string(),
        type: z.enum(['text', 'json', 'markdown', 'code', 'binary']),
        size: z.number().nonnegative(),
    })).optional(),
});
export const AgentStatusSchema = z.enum([
    'idle',
    'preparing',
    'running',
    'streaming',
    'completed',
    'cancelled',
    'failed'
]);
export const ProgressEventSchema = z.object({
    type: z.enum(['started', 'progress', 'completed', 'error', 'cancelled']),
    message: z.string(),
    percentage: z.number().min(0).max(100).optional(),
    data: z.any().optional(),
    timestamp: z.string().datetime(),
});
export const PipelineStepSchema = z.object({
    agent: z.string(),
    prompt: z.string(),
    dependsOn: z.array(z.string()).optional(),
    output_variable: z.string().optional(),
    timeout: z.number().optional(),
    streaming: z.boolean().optional(),
    condition: z.string().optional(),
});
export const PipelineErrorSchema = z.object({
    step: z.string(),
    agent: z.string(),
    message: z.string(),
    timestamp: z.string(),
});
export const PipelineResultSchema = z.object({
    success: z.boolean(),
    results: z.record(z.any()),
    metadata: z.object({
        totalSteps: z.number(),
        completedSteps: z.number(),
        totalExecutionTime: z.number(),
        totalCost: z.number(),
        errors: z.array(PipelineErrorSchema),
    }),
});
export const AssistantOptionsSchema = z.object({
    showReasoning: z.boolean().optional(),
    maxAutoCost: z.number().positive().optional(),
    force: z.boolean().optional(),
    onProgress: z.function(z.tuple([ProgressEventSchema]), z.void()).optional(),
});
export const PipelineAnalysisSchema = z.object({
    confidence: z.number().min(0).max(1),
    reasoning: z.string(),
    steps: z.array(PipelineStepSchema),
    complexity: z.enum(['simple', 'moderate', 'complex']),
    parallelExecution: z.boolean(),
});
export const AssistantResultSchema = z.object({
    analysis: PipelineAnalysisSchema,
    result: PipelineResultSchema,
    output: z.string(),
    totalCost: z.number().nonnegative(),
    totalTime: z.number().nonnegative(),
});
//# sourceMappingURL=execution-schemas.js.map